import styled from "styled-components";

export const Wrapper = styled.div``;

export const Content = styled.div`
  margin: 0 var(--right-left-margin);
  text-align: center;
  line-height: 180%;

  h1 {
    margin-bottom: 50px;
    color: var(--Bleu);
    font-size: 2.5em;
  }
`;
